import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-100">
      <div className="mx-auto px-4 py-12 md:px-10 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-accent-950">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-extrabold text-background-50">
                伊人在线
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              伊人在线聚焦精选电视剧与电影内容，为热爱影视娱乐的你提供最新影视资讯浏览、多维筛选与作品详情查询服务。本站为影视内容展示与信息查询平台，播放入口仅作信息指引，不提供实际播放、下载与付费功能。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li>
                <Link to="/" className="cursor-pointer transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="cursor-pointer transition-colors hover:text-accent-400">
                  影视分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="cursor-pointer transition-colors hover:text-accent-400">
                  搜索影视
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                客服邮箱：service@yiren-online.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400"></i>
                内容合作：partner@yiren-online.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                服务时间：每日 9:00 - 22:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row">
          <p>© 2026 伊人在线 Yiren Online. 保留所有权利。</p>
          <p>本站所有影视信息均为虚构演示内容，仅供产品展示使用。</p>
        </div>
      </div>
    </footer>
  );
}